// Local product data for the Binder Builders microsite.
// Single source of truth for product metadata used by the microsite.

export const products = [
  {
    slug: "builder-packs",
    name: "Builder Packs",
    subHeading: "10-card packs",
    priceLabel: "$5 each",
    heroLine: "Small Pokemon-only packs made for loot bags, rewards, gifts, and new collectors.",
    description:
      "Builder Packs are handout-sized 10-card packs built for kids who want to sort, trade, collect, and grow their binders. They are easy to give away, simple to tuck into a party bag, and put together with transparent, parent-friendly care.",
    bullets: [
      "10 Pokemon cards per pack",
      "No duplicates inside each individual 10-card pack",
      "No Energy or Trainer cards",
      "Great for loot bags, rewards, party favours, and new collectors",
    ],
    photos: [],
    ctaLabel: "Ask about Builder Packs",
    options: [
      {
        name: "Builder Pack Package",
        priceLabel: "$45",
        description:
          "Need several small packs? The Builder Pack Package is a simple option for loot bags, rewards, gifts, or group giveaways.",
        bullets: [
          "10 Builder Packs",
          "10 cards per pack",
          "100 total Pokemon cards",
          "No duplicates inside each individual 10-card pack",
          "No Energy or Trainer cards",
          "Best for loot bags, rewards, party favours, and group giveaways",
        ],
        ctaLabel: "Ask about Builder Pack Packages",
      },
    ],
    inventory: [
      {
        name: "Assorted Starter Pack",
        description: "A mixed 10-card pack with common and uncommon Pokemon cards.",
        quantity: 12,
      },
      {
        name: "Evolution Mini Pack",
        description: "A small pack built around simple evolution-line cards where available.",
        quantity: 6,
      },
      {
        name: "Party Prize Pack",
        description: "Easy giveaway packs prepared for birthdays, classrooms, or prize bins.",
        quantity: 18,
      },
    ],
  },

  {
    slug: "builder-bundles",
    name: "Builder Bundles",
    subHeading: "50-card bundles",
    priceLabel: "$20",
    heroLine: "A binder-ready bundle for starting or growing a Pokemon collection.",
    description:
      "Builder Bundles are curated 50-card bundles put together for binder builders. They are designed to give new collectors a bigger stack of clean, sorted cards ready to sleeve, sort, trade, and collect.",
    bullets: [
      "50 Pokemon cards",
      "No duplicates inside each individual bundle",
      "No Energy or Trainer cards",
      "Great for building binders, sorting, trading, and collecting",
    ],
    photos: [],
    ctaLabel: "Ask about Builder Bundles",
    inventory: [
      {
        name: "Mixed Binder Bundle",
        description: "A 50-card bundle with a balanced mix of Pokemon cards for general collecting.",
        quantity: 4,
      },
      {
        name: "Type Variety Bundle",
        description: "A 50-card bundle sorted to include a spread of different Pokemon types.",
        quantity: 3,
      },
      {
        name: "Trade Box Bundle",
        description: "A larger bundle meant for sorting, trading, and filling early binder pages.",
        quantity: 2,
      },
    ],
  },

  {
    slug: "builder-decks",
    name: "Builder Decks",
    subHeading: "60-card beginner decks",
    priceLabel: "$15 or 2/$25",
    heroLine: "Casual 60-card decks built to help new players learn Pokemon TCG.",
    description:
      "Builder Decks are casual 60-card beginner decks put together for kids who want to learn how to play the Pokemon Trading Card Game. They are built for learning turns, Energy, attacks, and Trainer cards in a low-pressure way, not tournament-focused play.",
    bullets: [
      "60-card casual deck",
      "Includes Pokemon, Trainer, and Energy cards",
      "Ready to play for casual learning",
      "Built for learning the game",
    ],
    photos: [],
    ctaLabel: "Ask about Builder Decks",
    options: [
      {
        name: "Builder Deck Battle Set",
        priceLabel: "$25",
        description:
          "Two casual beginner decks so players can sit down, learn the basics, and battle right away.",
        bullets: [
          "2 Builder Decks",
          "60 cards per deck",
          "120 total cards",
          "Each deck includes Pokemon, Trainer, and Energy cards",
          "Built for casual learning, not tournament-focused play",
          "Great for siblings, friends, or parent-child play",
        ],
        ctaLabel: "Ask about Builder Deck Battle Sets",
      },
    ],
    inventory: [
      {
        name: "Fire Starter Deck",
        description: "A simple 60-card beginner deck with straightforward attacks and Trainer cards.",
        quantity: 2,
      },
      {
        name: "Water Starter Deck",
        description: "A casual deck option built for learning turns, Energy, and basic strategy.",
        quantity: 1,
      },
      {
        name: "Grass Starter Deck",
        description: "A beginner-friendly deck with simple sequencing and easy play patterns.",
        quantity: 1,
      },
    ],
  },
];

export function getProductBySlug(slug) {
  return products.find((p) => p.slug === slug);
}
